// extracted by mini-css-extract-plugin
export default {"grid":"ProjectThumbnailsV5Grid_grid__efV7H"};